module.exports = __webpack_public_path__ + "img/guide.d6fd44d7.jpg";